// extracted by mini-css-extract-plugin
export default {"docCard":"DocCard_docCard__c1N8G","purpleShape":"DocCard_purpleShape__PiEDa","greenShape":"DocCard_greenShape__7yg58","docName":"DocCard_docName__NKwDP"};